module.exports = __webpack_public_path__ + "acf0218e0a0b7da71c44288eca25bbd9.svg";